import React from 'react';
import * as Contentful from 'contentful';
import LinkWrapper from '../link-wrapper/link-wrapper';
import { hasTitle, TypeCategorySkeleton } from '@fm-nx/contentful-types';
import slugify from '@sindresorhus/slugify';

export type HeaderGroupProps = {
    mode?: 'dark' | 'light';
    overline?: string;
    headerText?: Contentful.EntryFields.Symbol<string>;
    paragraph?: Contentful.EntryFields.Text;
    pageLinks?: TypeCategorySkeleton[] | undefined;
    listItems?: (string | undefined)[];
};

export const HeaderGroup = (props: HeaderGroupProps) => {
    const { mode = 'light', overline, headerText, paragraph, pageLinks, listItems } = props;
    const textColor = mode === 'dark' ? 'text-white' : 'text-gray-900';

    return (
        <div className="mx-6 md:mx-0 md:grid md:grid-cols-14">
            <div className="col-span-8 col-start-4">
                <div className="text-center">
                    <div className="space-y-6">
                        {overline && <h2 className={`${textColor} h5 overline`}>{overline}</h2>}
                        {headerText && <h3 className={`${textColor} h-xl`}>{headerText}</h3>}
                        {paragraph && <p className={`${textColor} px-8  p-xl`}>{paragraph}</p>}
                        {pageLinks && (
                            <ul className="space-y-6">
                                {pageLinks.map((link) => {
                                    if (!link || !hasTitle(link.fields)) return null;

                                    // Check if the technology has a slug (indicating it has a detail page)
                                    const hasSlug = link.fields.slug && link.fields.slug.trim() !== '';

                                    return (
                                        <li key={slugify(link.fields.title)}>
                                            {hasSlug ? (
                                                <LinkWrapper
                                                    className={`${textColor} inline-block mb-3 text-xl md:text-2xl font-headline border-b-out`}
                                                    page={link}
                                                >
                                                    {link.fields.title}
                                                </LinkWrapper>
                                            ) : (
                                                <span
                                                    className={`${textColor} inline-block mb-3 text-xl md:text-2xl font-headline`}
                                                >
                                                    {link.fields.title}
                                                </span>
                                            )}
                                        </li>
                                    );
                                })}
                            </ul>
                        )}
                        {listItems && (
                            <ul className="mt-4">
                                {listItems.map((item) => {
                                    if (!item) return null;
                                    return (
                                        <li
                                            key={slugify(item)}
                                            className={`${textColor} block mb-3 text-xl md:text-2xl font-headline`}
                                        >
                                            {item}
                                        </li>
                                    );
                                })}
                            </ul>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeaderGroup;
